module.exports = __webpack_public_path__ + "img/background11.b9df4b07.jpg";